import { render, staticRenderFns } from "./Greeting.vue?vue&type=template&id=45f5780e&scoped=true&"
import script from "./Greeting.vue?vue&type=script&lang=js&"
export * from "./Greeting.vue?vue&type=script&lang=js&"
import style0 from "./Greeting.vue?vue&type=style&index=0&id=45f5780e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5780e",
  null
  
)

export default component.exports